import { Trans, useTranslation } from 'react-i18next';

import { Button, Variant } from '@indicia/component-library';
import useBem from '@indicia/use-bem';

import getFileFromStorage from '../../../shared/utils/DownloadFile';

const AboutTest = () => {
  const { bemClassName, bemClassNames } = useBem('content-page');
  const { t, i18n } = useTranslation();

  const downloadAlgemeneVoorwaarden = () => {
    const isEn = i18n?.language?.toLowerCase()?.startsWith('en');
    const url = isEn
      ? window.__RUNTIME_CONFIG__.ALGEMENE_VOORWAARDEN_URL_EN || window.__RUNTIME_CONFIG__.ALGEMENE_VOORWAARDEN_URL
      : window.__RUNTIME_CONFIG__.ALGEMENE_VOORWAARDEN_URL;
    const name = isEn
      ? window.__RUNTIME_CONFIG__.ALGEMENE_VOORWAARDEN_NAME_EN || window.__RUNTIME_CONFIG__.ALGEMENE_VOORWAARDEN_NAME
      : window.__RUNTIME_CONFIG__.ALGEMENE_VOORWAARDEN_NAME;

    getFileFromStorage(url, name);
  };

  const downloadPrivacyStatement = () => {
    const isEn = i18n?.language?.toLowerCase()?.startsWith('en');
    const url = isEn
      ? window.__RUNTIME_CONFIG__.PRIVACY_STATEMENT_URL_EN || window.__RUNTIME_CONFIG__.PRIVACY_STATEMENT_URL
      : window.__RUNTIME_CONFIG__.PRIVACY_STATEMENT_URL;
    const name = isEn
      ? window.__RUNTIME_CONFIG__.PRIVACY_STATEMENT_NAME_EN || window.__RUNTIME_CONFIG__.PRIVACY_STATEMENT_NAME
      : window.__RUNTIME_CONFIG__.PRIVACY_STATEMENT_NAME;

    getFileFromStorage(url, name);
  };

  return (
    <div className={bemClassNames([bemClassName(), 'background-image'])}>
      <div className="container">
        <div className={bemClassName('title')}>
          <h1>{t('about-test.title')}</h1>
        </div>
        <div className={bemClassName('content')}>
          <Trans
            i18nKey="about-test.content"
            components={{
              p: <p />,
              p1: <p className="large" />,
              b: <strong />,
              i: <i />,
              ul: <ul />,
              li: <li />,
              lifelinesLink: (
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.lifelines.nl/"
                >
                  {' '}
                </a>
              ),
              algemeneVoorwaardenLink: (
                <Button
                  onClick={() => downloadAlgemeneVoorwaarden()}
                  variant={Variant.Plain}
                >
                  {t('generic.algemene-voorwaarden-small')!}
                </Button>
              ),
              privacyStatementLink: (
                <Button
                  onClick={() => downloadPrivacyStatement()}
                  variant={Variant.Plain}
                >
                  {t('generic.privacy-statement-small')!}
                </Button>
              ),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutTest;
